import { ServiceFetch } from '../service-fetch'

export default class ReceiptSaleDepositListModel extends ServiceFetch {
    getReceiptSaleDepositListBy = (data) => this.authFetch({
        url: 'receipt-sale-deposit-list/getReceiptSaleDepositListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}